import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  NEW_ANALYTICS_PRIVATE_READERSHIP_PROFILE_STATE_POST_PREVIEW_FOR_READERSHIP_PROFILE_ACTION,
  NEW_ANALYTICS_READERSHIP_PROFILE_STATE_GET_PREVIEW_FOR_READERSHIP_PROFILE_ACTION,
  NEW_ANALYTICS_READERSHIP_PROFILE_STATE_POST_PREVIEW_FOR_READERSHIP_PROFILE_ACTION,
  NEW_ANALYTICS_READERSHIP_PROFILE_STATE_PUT_ANALYTICS_BY_ID_VALIDATE,
} from '../../prefix-actions.config'
import { RootState } from '../../store'
import { postReadershipProfilePreviewService } from '../../../core/api/services/bookmetrie/analytics/post-readership-profile-preview.service'
import { BookInterface } from '../../../core/interface/book.interface'
import { postReportByIdPurchaseService } from '../../../core/api/services/bookmetrie/post-report-by-id-purchage.service'
import { postReportByIdReadershipProfileValidateService } from '../../../core/api/services/bookmetrie/post-report-by-id-readership-profile-validate.service'
import { setReadershipProfileGenerating } from '../../reducers/web-app.reducer'
import { newReadershipProfileStateSetPostPreviewTypeError } from '../../reducers/analytics-details/new-analytics-readership-profile-state.reducer'
import getAnalyticsIdsValueUtils from '../../../core/utils/getAnalyticsIdsValue.utils'
import { postPrivateReadershipProfilePreviewService } from '../../../core/api/services/bookmetrie/analytics/post-private-readership-profile-preview.service'
import { StudyObjectGroupCompareEnum } from '../../../components/analytics-details-v2/view/readership-profile/configs/StudiesObjectsCompareGroupTypesConfig'

export const newAnalyticsReadershipProfileStateGetPreviewForReadershipProfile =
  createAsyncThunk(
    NEW_ANALYTICS_READERSHIP_PROFILE_STATE_GET_PREVIEW_FOR_READERSHIP_PROFILE_ACTION,
    async (
      { previewId }: { previewId: string },
      { getState },
    ): Promise<any> => {
      try {
        return await new Promise((resolve, reject) => {
          setTimeout(() => {
            Math.random() > 0.2 ? resolve(true) : reject()
          }, 1000)
        })
      } catch (error) {
        throw new Error()
      }
    },
  )

export const newAnalyticsReadershipProfileStatePostPreviewForReadershipProfile =
  createAsyncThunk(
    NEW_ANALYTICS_READERSHIP_PROFILE_STATE_POST_PREVIEW_FOR_READERSHIP_PROFILE_ACTION,
    async (_, { getState, dispatch }): Promise<any> => {
      try {
        const { newAnalyticsReadershipProfileState } = getState() as RootState
        const {
          analyticsName,
          studyObjectType,
          studyObjectValue,
          studyObjectBooks,
          compareGroupType,
          compareGroupValue,
          compareGroupBooks,
        } = newAnalyticsReadershipProfileState

        const { data } = await postReadershipProfilePreviewService({
          title: analyticsName,
          studyObject: {
            type: studyObjectType,
            ids: getAnalyticsIdsValueUtils(studyObjectType, studyObjectValue),
            eans: studyObjectBooks.map((book: BookInterface) => book.id_ean),
          },
          compareGroup: {
            type: compareGroupType,
            ids: getAnalyticsIdsValueUtils(compareGroupType, compareGroupValue),
            eans: compareGroupBooks.map((book: BookInterface) => book.id_ean),
          },
        })

        return data
      } catch (error: any) {
        if (error.response.data.errors[0].code) {
          dispatch(
            newReadershipProfileStateSetPostPreviewTypeError(
              error.response.data.errors[0].code,
            ),
          )
        }

        throw new Error()
      }
    },
  )

export const newAnalyticsPrivateReadershipProfileStatePostPreviewForReadershipProfile =
  createAsyncThunk(
    NEW_ANALYTICS_PRIVATE_READERSHIP_PROFILE_STATE_POST_PREVIEW_FOR_READERSHIP_PROFILE_ACTION,
    async (_, { getState, dispatch }): Promise<any> => {
      try {
        const { newAnalyticsReadershipProfileState } = getState() as RootState
        const {
          analyticsName,
          studyObjectType,
          studyObjectValue,
          studyObjectBooks,
          compareGroupType,
          compareGroupValue,
          compareGroupBooks,
          studyObjectFiltersPayload,
          compareGroupFiltersPayload,
          studyObjectFiltersActions,
          compareGroupFiltersActions,
        } = newAnalyticsReadershipProfileState

        const preview = {
          title: analyticsName,
          studyObject: {
            type: studyObjectType,
            ids: getAnalyticsIdsValueUtils(studyObjectType, studyObjectValue),
            eans: studyObjectBooks.map((book: BookInterface) => book.id_ean),
          },
          compareGroup: {
            type: compareGroupType,
            ids: getAnalyticsIdsValueUtils(compareGroupType, compareGroupValue),
            eans: compareGroupBooks.map((book: BookInterface) => book.id_ean),
          },
          subject_book_filters: {
            ...(studyObjectFiltersActions.format?.length && {
              book_format: studyObjectFiltersActions.format,
            }),
            ...(studyObjectFiltersActions.edition?.length && {
              edition: studyObjectFiltersActions.edition,
            }),
            ...(Array.isArray(studyObjectFiltersActions.publishing_date) &&
              studyObjectFiltersActions.publishing_date[0] != null && {
                year_start: studyObjectFiltersActions.publishing_date[0],
              }),
            ...(Array.isArray(studyObjectFiltersActions.publishing_date) &&
              studyObjectFiltersActions.publishing_date[1] != null && {
                year_end: studyObjectFiltersActions.publishing_date[1],
              }),
          },
          subject_users_filters: {
            ...(studyObjectFiltersPayload.added_in_library_first_date && {
              added_in_library_first_date:
                studyObjectFiltersPayload.added_in_library_first_date,
            }),
            ...(studyObjectFiltersPayload.added_in_library_last_date && {
              added_in_library_last_date:
                studyObjectFiltersPayload.added_in_library_last_date,
            }),
            ...(studyObjectFiltersPayload.tags.length > 0 && {
              tags: studyObjectFiltersPayload.tags,
            }),
            ...(studyObjectFiltersPayload.min_books_ownd_in_input && {
              min_books_ownd_in_input:
                studyObjectFiltersPayload.min_books_ownd_in_input,
            }),
          },
          comparison_book_filters: {
            ...(compareGroupFiltersActions.format?.length && {
              book_format: compareGroupFiltersActions.format,
            }),
            ...(compareGroupFiltersActions.edition?.length && {
              edition: compareGroupFiltersActions.edition,
            }),
            ...(Array.isArray(compareGroupFiltersActions.publishing_date) &&
              compareGroupFiltersActions.publishing_date[0] != null && {
                year_start: compareGroupFiltersActions.publishing_date[0],
              }),
            ...(Array.isArray(compareGroupFiltersActions.publishing_date) &&
              compareGroupFiltersActions.publishing_date[1] != null && {
                year_end: compareGroupFiltersActions.publishing_date[1],
              }),
          },
          comparison_users_filters: {
            ...(compareGroupFiltersPayload.added_in_library_first_date && {
              added_in_library_first_date:
                compareGroupFiltersPayload.added_in_library_first_date,
            }),
            ...(compareGroupFiltersPayload.added_in_library_last_date && {
              added_in_library_last_date:
                compareGroupFiltersPayload.added_in_library_last_date,
            }),
            ...(compareGroupFiltersPayload.tags.length > 0 && {
              tags: compareGroupFiltersPayload.tags,
            }),
            ...(compareGroupFiltersPayload.min_books_ownd_in_input && {
              min_books_ownd_in_input:
                compareGroupFiltersPayload.min_books_ownd_in_input,
            }),
          },
        }

        const studyFile =
          studyObjectType === StudyObjectGroupCompareEnum.USERS_LIST
            ? studyObjectValue
            : null
        const compareFile =
          compareGroupType === StudyObjectGroupCompareEnum.USERS_LIST
            ? compareGroupValue
            : null

        const { data } = await postPrivateReadershipProfilePreviewService(
          preview,
          studyFile,
          compareFile,
        )

        return data
      } catch (error: any) {
        if (error.response.data.errors[0].code) {
          dispatch(
            newReadershipProfileStateSetPostPreviewTypeError(
              error.response.data.errors[0].code,
            ),
          )
        }

        throw new Error()
      }
    },
  )

export const newAnalyticsReadershipProfileStatePutAnalyticsByIdValidate =
  createAsyncThunk<
    null,
    { reportId: string; isPrivate?: boolean },
    { state: RootState }
  >(
    NEW_ANALYTICS_READERSHIP_PROFILE_STATE_PUT_ANALYTICS_BY_ID_VALIDATE,
    async (
      { reportId, isPrivate = false },
      { getState, dispatch },
    ): Promise<null> => {
      const { webAppState } = getState()
      try {
        if (!isPrivate) {
          const { status } = await postReportByIdPurchaseService({ reportId })
          if (status !== 201) {
            return null
          }
        }
        const { data } = await postReportByIdReadershipProfileValidateService({
          reportId,
        })

        dispatch(
          setReadershipProfileGenerating([
            ...webAppState.readershipProfileGenerating,
            { data, show: true, isPrivate },
          ]),
        )

        return null
      } catch {
        throw new Error()
      }
    },
  )
